var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"cool-shaddow appbar"},[_c('div',{staticClass:"expande-horizontal pt-2 pl-2"},[_c('img',{attrs:{"height":"40","src":"img/logo_mini.png"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }